import React from "react";
import classes from "./Posts.module.css";
import { IoEyeSharp } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import { BiCategory } from "react-icons/bi";

const Posts = ({
  postsList,
  handlePostDelete,
  showPendingPosts,
  showSliderPosts,
  handlePostApproval,
  handleToggleSlider,
  deleteLoading,
  selectedIds = new Set(),
  onToggleSelect,
}) => {
  return (
    <>
      {postsList &&
        postsList.map((post, index) => {
          const isSlider = !!post.is_slider;
          return (
            <div className={classes.postsList + " mb-4"} key={post.id || index}>
              <div className={classes.selectCheckbox}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedIds.has(post.id)}
                  disabled={deleteLoading}
                  onChange={() => onToggleSelect?.(post.id)}
                  aria-label={`Select ${post.title || "post"}`}
                />
              </div>
              <div className="d-flex">
                <div className={classes.postListImage}>
                  <img src={post.thumbnail} alt="Thumbnail" />
                </div>
                <div className={classes.postDetails}>
                  <h4>{post.title === "" ? "No Title" : post.title}</h4>
                  <div>
                    <div>{post.description}</div>
                    <div>
                      <FaUserAlt /> {post.uploader_details?.name}
                      <IoEyeSharp className="ms-2" /> {post.views}
                    </div>
                    <div>
                      <BiCategory /> {post.category}
                      {isSlider && (
                        <span className="ms-2 badge bg-primary">
                          Slider #{post.slider_order || 0}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className={`ms-3 ${classes.postButtons}`}>
                <a
                  href={post.url}
                  className={"btn btn-outline-primary me-2 mb-2"}
                  target="_blank"
                  rel="noreferrer"
                  aria-disabled={deleteLoading}
                >
                  View
                </a>
                {showPendingPosts && (
                  <button
                    className="btn btn-outline-success me-2 mb-2"
                    disabled={deleteLoading}
                    onClick={() => {
                      handlePostApproval(post.id);
                    }}
                  >
                    Approve
                  </button>
                )}
                {!showPendingPosts && (
                  <button
                    className={`btn me-2 mb-2 ${
                      isSlider ? "btn-warning" : "btn-outline-warning"
                    }`}
                    disabled={deleteLoading || !post.thumbnail}
                    title={
                      !post.thumbnail
                        ? "Post needs a thumbnail to be a slider"
                        : undefined
                    }
                    onClick={() => handleToggleSlider(post)}
                  >
                    {isSlider || showSliderPosts
                      ? "Remove from Slider"
                      : "Promote to Slider"}
                  </button>
                )}
                <button
                  className="btn btn-outline-danger mb-2"
                  disabled={deleteLoading}
                  onClick={() => {
                    handlePostDelete(post);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default Posts;
